<template>
  <div class="am-discount-addon">
   <div class="am-discount-title-bar am-main-top-box">
     <span class="am-discount-title am-main-top-box-title"><strong>{{title}}</strong></span>
   </div>
   <div class="am-discount-form">
     <div class="form-row">
       <div class="form-group col-md-6">
         <label>Base Price</label>
         <input type="number" class="form-control" :disabled="isDisabled" v-model="baseOfficePriceDisplay">
       </div>
       <div class="form-group col-md-6">
         <label>Client Price</label>
         <input type="number" class="form-control" :disabled="isDisabled" v-model="officeAmountAfterDiscount">
       </div>
     </div>
     <div class="form-row">
       <div class="form-group col-md-6">
         <label>Name</label>
         <select class="form-control" v-model="newAddOn.addon_id" @change="prePopulate()">
           <option value='0' > Choose... </option>
           <option v-for="addOn in addOns" :value="addOn.id" :key="addOn.id">{{addOn.name}}</option>
         </select>
       </div>
       <div class="form-group col-md-6">
         <label>Billing Type</label>
         <input type="text" class="form-control" :disabled="isDisabled" v-model="newAddOn.bill_type">
       </div>
     </div>
     <div class="form-row">
       <div class="form-group col-md-6">
         <label>Sales Rep</label>
         <select class="form-control" v-model="newAddOn.salesRep">
           <option value='0' >-Select a Sales Rep-</option>
           <option v-for="salesRep in salesReps" :value="salesRep.id" :key="salesRep.id">{{salesRep.name}}</option>
         </select>
       </div>
       <div class="form-group col-md-6">
         <label class="w-100">Lifetime Discount</label>
         <div class="form-row">
           <div class="col-md-3">
             <select class="form-control" v-model="newAddOn.lifetime_discounts.amountType">
               <option v-for="discount in discountToGive" :key="discount.value" :value="discount.value">{{discount.display}}</option>
             </select>
           </div>
           <div class="col-md-9">
             <input type="number" class="form-control" placeholder='0' v-model="newAddOn.lifetime_discounts.amount" @keypress="isNumber($event, newAddOn.lifetime_discounts.amount)" @change="formatNumber(newAddOn.lifetime_discounts, 'amount')">
           </div>
         </div>
       </div>
     </div>

     <discounts :discounts="newAddOn.discounts" :isEdit="true" :deleteDiscount="isEdit" @updateDiscounts="updateDiscounts"></discounts>

     <div class="form-row">
       <div class="form-group col-md-12">
         <div class="am-discount-blue-border"></div>
       </div>
     </div>
     <div class="form-row">
       <div class="form-group col-md-12">
         <div class="am-discount-align-bottom-buttons">
          <div class="am-discount-float-right">
            <button type="button" class="btn btn-secondary" @click="closeModal()">Cancel</button>
            <button type="button" class="btn btn-primary" @click="onSubmit">Submit</button>
          </div>
        </div>
       </div>
     </div>
   </div>
  <modal name="MessagePopup" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3"  :adaptive="true" width="370px" height="auto">
    <message-popup :confirmDelete="false" :errors="messageString" messageHeader="Error" :isError="true"></message-popup>
  </modal>
  </div>
</template>

<script>
import api from './../http'
import moment from 'moment'
import Discounts from '@/components/DiscountSection'
import MessagePopup from './MessagePopup'
export default {
  name: 'AddOns',
  data () {
    return {
      discountToGive: [
        {
          value: 'A',
          display: '$'
        },
        {
          value: 'P',
          display: '%'
        }
      ],

      messageString: '',
      newAddOn: {
        id: 0,
        addon_id: 0,
        salesRep: 0,
        bill_type: '',
        cost: 0,
        employeeId: this.$store.state.auth.user.id,
        lifetime_discounts: {
          id: 0,
          employeeId: this.$store.state.auth.user.id,
          isLifetime: 1,
          amount: 0,
          amountType: 'A'
        },
        discounts: [{
          id: 0,
          employeeId: this.$store.state.auth.user.id,
          amountType: 'P',
          amount: 0,
          effectiveDate: '',
          expirationDate: ''
        }]
      },
      salesReps: 'Select a Sales Rep',
      isDisabled: true,
      counterRow: 1,
      client_price: 0,
      keySorted: {}
    }
  },

  props: {
    isEdit: Boolean,
    editAddOn: {
      type: Object,
      default: null
    },
    accountId: Number
  },

  asyncComputed: {
    addOns: {
      get () {
        return api.makeRequest('/backoffice/addOnsList').then(
          (data) => {
            return data.data.data
          }
        )
      }
    },

    salesReps: {
      get () {
        return api.makeRequest('/backoffice/backofficeSalesmen').then(
          (data) => {
            return data.data.results
          }
        )
      }
    }
  },

  components: {
    Discounts,
    MessagePopup
  },

  computed: {
    officeAmountAfterDiscount () {
      let self = this
      let afterDiscount = self.newAddOn.cost
      if (self.newAddOn.lifetime_discounts !== null && !isNaN(self.newAddOn.lifetime_discounts.amount)) {
        afterDiscount -= (self.newAddOn.lifetime_discounts.amountType === 'P') ? self.newAddOn.lifetime_discounts.amount / 100 * self.newAddOn.cost : self.newAddOn.lifetime_discounts.amount
      }

      let sortedDiscounts = JSON.parse(JSON.stringify(self.newAddOn.discounts))
      sortedDiscounts.sort(function (a, b) {
        if (a.amountType === b.amountType) {
          return 0
        }
        return (a.amountType < b.amountType) ? -1 : 1
      })

      sortedDiscounts.forEach(function (discount) {
        let effDate = moment(discount.effectiveDate, 'YYYY-MM-DD')
        let today = moment(new Date().toISOString().slice(0, 10), 'YYYY-MM-DD')

        if (today.diff(effDate) >= 0 && !isNaN(discount.amount)) {
          afterDiscount -= (discount.amountType === 'P') ? discount.amount / 100 * afterDiscount : discount.amount
        }
      })

      return afterDiscount.toFixed(2)
    },

    baseOfficePriceDisplay () {
      return this.newAddOn.cost.toFixed(2)
    },

    title () {
      return !this.isEdit ? 'Apply Add-On' : 'Edit Add-On'
    }
  },

  mounted () {
    let self = this
    if (this.editAddOn !== null) {
      api.makeRequest('backoffice/accountAddOn/' + this.editAddOn.id).then(
        (data) => {
          self.newAddOn = data.data.results[0]
          self.accountId = self.newAddOn.acct_id
          self.newAddOn.employeeId = self.$store.state.auth.user.id
          if (self.newAddOn.lifetime_discounts === null) {
            self.setBlankLifetimeDiscount()
          }
          if (self.newAddOn.discounts.length === 0) {
            self.setBlankDiscount()
          }
        }
      )
    }
  },

  methods: {
    setBlankLifetimeDiscount () {
      this.newAddOn.lifetime_discounts = {
        id: 0,
        amountType: 'A',
        amount: 0,
        employeeId: this.$store.state.auth.user.id,
        isLifetime: 1
      }
    },

    setBlankDiscount () {
      this.newAddOn.discounts = [
        {
          id: 0,
          amountType: 'P',
          amount: 0,
          effectiveDate: '',
          expirationDate: '',
          employeeId: this.$store.state.auth.user.id
        }
      ]
    },

    updateDiscounts (discounts) {
      this.newAddOn.discounts = discounts
    },

    messagePopup: function () {
      this.$modal.show('MessagePopup')
      document.body.style.overflow = "hidden";

    },

    validate () {
      let self = this
      let valid = true
      this.messageString = ''
      this.newAddOn.discounts.forEach(function (discount) {
        let effDate = moment(discount.effectiveDate, 'YYYY-MM-DD')
        let expDate = moment(discount.expirationDate, 'YYYY-MM-DD')
        let today = moment(new Date().toISOString().slice(0, 10), 'YYYY-MM-DD')

        if (today.diff(effDate) > 0 && discount.id === 0) {
          valid = false
          self.messageString += 'New Discounts must have effective date starting today or later.' + '\n\n'
        }
        if (expDate.diff(effDate) < 0) {
          valid = false
          self.messageString += 'Expiration date cannot be before effective date.' + '\n\n'
        }
      })

      if (parseFloat(this.officeAmountAfterDiscount) < 0) {
        valid = false
        this.messageString += 'Total discounts cannot be greater than the base price.' + '\n\n'
      }

      if (valid === false) {
        this.messagePopup()
      }
      return valid
    },

    formatNumber (object, attribute) {
      if (object[attribute].length === 0) {
        object[attribute] = '0'
      } else {
        object[attribute] = +object[attribute]
      }
    },

    isNumber (event, value) {
      event = (event) || window.event
      var charCode = (event.which) ? event.which : event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault()
      } else if (charCode === 46 && value.includes('.')) {
        event.preventDefault()
      } else {
        return true
      }
    },

    prePopulate () {
      let addOn = this.addOns.find(i => i.id === this.newAddOn.addon_id)
      this.newAddOn.bill_type = addOn.bill_type
      this.newAddOn.cost = addOn.cost
      this.client_price = addOn.cost
    },

    closeModal () {
      this.$store.dispatch('events/fireEvent', { name: 'add-on-close', data: null })
      this.$modal.hide('addOn')
    },

    onSubmit () {
      if (this.validate()) {
        let data = this.newAddOn
        let self = this
        api.postRequest('/backoffice/accountAddOnsAdd/' + this.accountId, data).then(
          (data) => {
            self.closeModal()
            location.reload()
          }
        ).catch(function (error) {
          let errorData = error.response.data['Improperly formatted request']
          self.messageString = ''
          for (var value in errorData) {
            self.messageString += errorData[value] + '\n'
          }
          self.messagePopup()
        })
      }
    }
  }
}
</script>

<style scoped>
    .am-discount-addon {
      width: 710px;
      background-color: white;
      height: auto;
      overflow: hidden;
    }

    .am-discount-title-bar {
      height: 40px;
    }

    .am-discount-title {
      font-size: 16px;
      color: #FDFEFE;
      float: left;
      margin: 10px 0px 0px 15px;
    }

    .am-discount-blue-border {
      display: block;
      width: 100%;
      border-top: 1px solid #4297d7;
    }

    .am-discount-form {
      padding: 15px 15px 18px 15px;
    }

    .am-discount-form label {
      font-weight: bold;
    }

    .am-discount-form input,select {
      border-radius: 0;
    }

    .am-discount-float-right {
     margin-left: 510px;
    }

    .col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-9,.col-md-12 {
      padding-left: 5px;
      padding-right: 5px;
    }

    .form-row {
      margin-right: -5px;
      margin-left: -5px;
      display: flex;
      flex-wrap: wrap;
    }

    label {
      display: inline-block;
      margin-bottom: 0.5rem;
    }
   .v--modal-overlay {
      background-color: rgba(0,0,0,0.6) !important;
    }
</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
